export function removeByElement(arr, elementOrPredicate) {
  const index = arr.indexOf(elementOrPredicate);
  if (index > -1) {
    arr.splice(index, 1);
  }
}

export function removeByIndex(arr, index) {
  arr.splice(index, 1);
}

export function insertAtIndex(arr, element, index) {
  arr.splice(index, 0, element);
}

export function moveByIndex(arr, fromIndex, toIndex) {
  const fromElement = arr[fromIndex];
  moveToIndex(arr, fromElement, toIndex);
}

export function moveByElement(arr, fromElement, toElement) {
  const toIndex = arr.indexOf(toElement);
  moveToIndex(arr, fromElement, toIndex);
}

export function moveToIndex(arr, element, index) {
  removeByElement(arr, element);
  insertAtIndex(arr, element, index);
}
